__webpack_require__.p = "/getting-started-drawer-container/system-email-templates/";